export default {
      id: "ic-misc-search-usage",
      viewBox: "0 0 15 15",
      url: "../dist/images/" + "sprite.svg#ic-misc-search-usage",
      toString: function () {
        return this.url;
      }
    }